import { clientDayKey, clientTime, shortDateTime } from '../../shared/dateTime';
import { plNumber } from '../../shared/number';
import type { DriverShift } from './suggestionsApi';

/**
 * Chwila w czasie polskim krótko: dziś — sama godzina („06:12”), innego
 * dnia — z dniem („05.10, 22:30”), żeby godzina nie myliła.
 */
export function timeTodayOrDate(iso: string, now: Date = new Date()): string {
  return clientDayKey(new Date(iso)) === clientDayKey(now)
    ? clientTime(iso)
    : shortDateTime(iso);
}

/**
 * Druga linia pod „dziś może jechać jeszcze” (06.10.2026): od kiedy trwa
 * zmiana kierowcy i ile zostało do odpoczynku dobowego — z osi czasu
 * tachografu (backend: `user-offers/driver-timeline.ts`). Czas polski;
 * zmiana z dzisiaj samą godziną, starsza z dniem. Zapas to szacunek („ok.”).
 * Gdy odpoczynek już jest wymagany, zostaje sam początek zmiany — powód stoi
 * w linii „dostępny od”.
 */
export function driverShiftText(shift: DriverShift, now: Date = new Date()): string {
  const from = timeTodayOrDate(shift.startedAt, now);
  return shift.dutyLeftH > 0
    ? `zmiana od ${from}, do odpoczynku ok. ${plNumber(shift.dutyLeftH)} h`
    : `zmiana od ${from}`;
}
